import React from 'react'
import classNames from 'classnames'
import s from './LayersButtons.less'
import T from '../../i18n/T'
import { useSelector } from 'react-redux'
import { selectMapMode, selectMapTheme } from '../../../store/map/map.selectors'
import { useAction } from '../../utils/react-redux'
import { setMapMode, setMapTheme } from '../../../store/map/map.actions'
import useEventCallback from '../../utils/useEventCallback'
import { MAP_THEMES, MAP_MODES } from '../../../store/map/map.constants'
import SVGIcon from '../../svg/SVGIcon'

export const ModeLayerButton = ({ icon, id, disabled }) => {
  const execSetMode = useAction(setMapMode)
  const active = id === useSelector(selectMapMode)

  if (active && disabled) execSetMode(MAP_MODES.neutral)

  const onClick = useEventCallback(() => execSetMode(active ? MAP_MODES.neutral : id), [execSetMode, active, id])

  return (
    <div
      onClick={onClick}
      className={classNames(s.layerButton, s.modeButton, active && s.activeButton, disabled && s.disabledLayerButton)}
    >
      <div className="icon">
        <SVGIcon icon={icon} className={classNames(disabled && s.greyedIcon)} />
      </div>
      <span className={classNames(s.label, disabled && s.disabledLabel)}>
        <T id={`map.tools.layers.${id}`} />
      </span>
    </div>
  )
}

export const ThemeLayerButton = ({ icon, id, disabled }) => {
  const execSetTheme = useAction(setMapTheme)
  const active = id === useSelector(selectMapTheme)

  if (active && disabled) execSetTheme(MAP_THEMES.normal)

  const onClick = useEventCallback(() => execSetTheme(active ? MAP_THEMES.normal : id), [execSetTheme, active, id])

  return (
    <div
      onClick={onClick}
      className={classNames(s.layerButton, s.themeButton, active && s.activeButton, disabled && s.disabledLayerButton)}
    >
      <div className="icon">
        <img src={icon} className={classNames(disabled && s.greyedIcon)} />
      </div>
      <span className={classNames(s.label, disabled && s.disabledLabel)}>
        <T id={`map.tools.layers.${id}`} />
      </span>
    </div>
  )
}
